module.exports = __webpack_public_path__ + "static/img/logo.a8afd34.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.jpg
// module id = do/+
// module chunks = 1